import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import template from 'gocatss-debugger.j2';

function afterConstruction(store) {
    this.render(store, this, {});
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-gocatss-debugger',
        watch: ['core.gocatssDebuggerIsActive'],
        name: 'gocatssDebuggerComponent',
        template: template,
        afterConstruction: afterConstruction
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}
